import { Component, EventEmitter, Input, Output } from '@angular/core';
import {  FormControl, FormGroup, Validators } from '@angular/forms';
import { UtilsNotificationService } from 'src/app/utils/utils-notification.service';
import { RequestEmployeeUtilsService } from '../../benefit-application/utils/request-employee-utils.service';
import { RequestFormService } from 'src/app/home/services/request-form.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommmonService } from 'src/app/utils/common.service';

@Component({
  selector: 'app-modal-form-desaffiliation',
  templateUrl: './modal-form-desaffiliation.component.html',
  styleUrls: ['./modal-form-desaffiliation.component.scss'],
})
export class ModalFormDesaffiliationComponent {
  @Output() closeModalPlan = new EventEmitter();
  @Input() miplan!:string;
  @Input() idplan!:number;
  emptyFieldForm = false;
  isLoading=false;
  benefits!:any[];
  id_beneficio!:number;
  nombre= new FormControl('');
  apellidoPaterno= new FormControl('');
  rut= new FormControl(''); 
  email= new FormControl(''); 
  telefono= new FormControl('');

  form: FormGroup = new FormGroup({
    nombre: this.nombre,
    apellidoPaterno: this.apellidoPaterno,
    rut: this.rut,
    telefono: this.telefono,
    email: this.email,
  })
  


  constructor(
    private utilsService: UtilsNotificationService,
    private employeeFormUtil: RequestEmployeeUtilsService,
    private requestFormService: RequestFormService,
    private router: Router,
    private commonService: CommmonService,
    private route: ActivatedRoute,
  ) {
    this.addFormValidators()
  }

  ngOnInit(){
    this.getIdBenefitFalp()
  }
  private addFormValidators(): void {
    this.nombre.setValidators([Validators.required]);
    this.apellidoPaterno.setValidators([Validators.required]);
    this.rut.setValidators([Validators.required]);
    this.email.setValidators([Validators.required, Validators.email]);
    this.telefono.setValidators([Validators.required])
  }

  onKeyPress(event: KeyboardEvent) {
    if (!this.utilsService.onlyNumbers(event)) {
      event.preventDefault();
    }
  }

  getIdBenefitFalp(){
    this.benefits = this.commonService.sortArray(
      this.route.snapshot.data['resolverBenefit'] ?? [],
    ); 
     const beneficio_desafiliacion = this.benefits.length === 0
      ? undefined
      : this.benefits.find((b: any) => b.title === "Desafiliación");
    this.id_beneficio = beneficio_desafiliacion.id  

  }

  enviarFormulario(): void {
    if (this.isLoading) {
      return;
    }
    if (this.form.valid && !this.emptyFieldForm ) {
      this.isLoading=true;
      this.postSolicitud()
       // Puedes agregar la lógica que necesites para cerrar el modal o procesar los datos
    } else {
      this.emptyFieldForm=true;
    }
  }

  closeModal() {
    this.closeModalPlan.emit(false);
  }

  postSolicitud(){
    const formData = this.employeeFormUtil.transformFormData(
      this.form.value,
    );
     const payload = {
      informacion_personal: {
        Nombres: formData.nombre,
        Apellidos: formData.apellidoPaterno,
        RUT: formData.rut,
        Teléfono: formData.telefono,
        Email: formData.email,
      },
      beneficiarios: {},
      direccion: {},
      informacion_adicional: {
        Plan_proveniente: { 
          valor:this.miplan,
          corregir:false,
          index:6}
      },
      archivos: [],
      atributos_corregir: {
        motivo_correccion: '',
        comentario_correccion: '',
        campos_corregir: [],
      },
      motivo_rechazo: '',
      idPlanSelected:this.idplan,
      esCambioPlan:{
        esCambioPlan : true,
        idPlanCambio: this.idplan
      } ,
      formulario: ""
    };
    
    this.formBenefits_post(payload);
  }

  async formBenefits_post(form: any) {
    
    try {
      const request = {
        beneficio_id: this.id_beneficio,
        estado_solicitud_id: 1,
        formulario: JSON.stringify(form),
      };
      await this.requestFormService
        .postRequestForms(request)
        .then((response: any) => {
          if (response?.statusCode === 200) {
            this.router.navigate(['/successful-request', { success: true }]);
            this.form.reset();
            this.closeModal(); 
            this.isLoading=false;
          }
        });
    } catch (error: any) {
      this.router.navigate(['/successful-request', { success: false }]);
      this.form.reset();
      this.closeModal(); 
      this.isLoading = false;
    }
  
  }
}
